import { Component, OnChanges, Input, SimpleChanges, ViewEncapsulation } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
// import { DataService } from '../../data.service';
import { Router } from "@angular/router";

@Component({
  selector: "lc-content-block",
  templateUrl: "./content-block.component.html",
  styleUrls: ["./content-block.component.scss"],
  encapsulation: ViewEncapsulation.None, // disable CSS Encapsulation since to may include HTML
})

export class ContentBlockComponent implements OnChanges {
  @Input() block;
  @Input() lang: string;
  @Input() keywords: string;
  @Input() version: number = 0;
  @Input() preview: boolean = false;
  @Input() isFirstBlock;

  block_attributes = ['title', 'paragraph', 'paragraphBottom'];
  public content_col_names = ['contentLeft', 'contentRight']; // TODO allow for more cols !?

  constructor(
    private sanitizer: DomSanitizer,
    //public dataService: DataService,
    private router: Router
  ) {}

  _prepare_search(contentColName){
    if( !!this.block[contentColName] ){
      for( const att of this.block_attributes ){
        if( !!this.block[contentColName][att] && !!this.block[contentColName][att][this.lang] ){
          this.block[contentColName][att][this.lang+'_clean'] = this.block[contentColName][att][this.lang] + ' ';
        }
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    if ( !!changes.block || this.preview ){
      this.block.xstyles = { ...this.block.styles };
      if (!!this.block.bg_img) {
        // TODO: check if the image is valid and downloadable ?
        this.block.xstyles["background-image"] = `url(${this.block.bg_img})`;
      }
      if (!!this.block.height) {
        this.block.xstyles["min-height"] = `${this.block.height}px`;
      }
      if (!!this.block.padding_top) { // TODO: better use a class here i.s.o. hard style override
        this.block.xstyles["padding-top"] = `${this.block.padding_top}px`;
      }
      if (!!this.block.contentLeft) {
        if( this.block.contentLeft.width == undefined ){
          this.block.contentLeft.width = 6;
        }
        for( const att of this.block_attributes ){
          if(!!this.block.contentLeft[att] && !!this.block.contentLeft[att][this.lang]){
            this.block.contentLeft[att][this.lang+'_clean'] = this.block.contentLeft[att][this.lang] + ' '; 
          }
        }
      }
      if (!!this.block.contentRight) {
        this.block.contentRight.width = 12 - this.block.contentLeft.width;
        for( const att of this.block_attributes ){
          if(!!this.block.contentRight[att] && !!this.block.contentRight[att][this.lang]){
            this.block.contentRight[att][this.lang+'_clean'] = this.block.contentRight[att][this.lang] + ' '; 
          }
        }
      }
    }
    if ( !!changes.block && !this.preview) {
      this._prepare_search('contentLeft');
      this._prepare_search('contentRight');
    }
    // if (!!changes.keywords && !!changes.keywords.currentValue && changes.keywords.currentValue.length > 2) this.filter_content();
    if (!!changes.keywords) this.filter_content();
  }
  
  _mark_kw(s, kw){

    if( !kw || kw.length == 0){
      return s;
    }
    let r = '';
    if( !!s && s.length > 0){
      const clean_kw = kw.trim().replace(/\s+/g, '|')
      const re = new RegExp(`(${clean_kw})`, 'ig');
      try{
        r = s.replace(re, '<strong class="search">$1</strong>');
      } catch(e){
        console.debug(e);
      }
    } else {
      r = null;
    }
    return r;
  }

  filter_content(){
    this.block.visible = false;
    let kw_seen = 0;
    for( const att of this.block_attributes ){
      if(!!this.block.contentLeft[att]){
          const marked = this._mark_kw(this.block.contentLeft[att][this.lang + '_clean'], this.keywords);
          if( this.block.contentLeft[att][this.lang] !== marked ){
            kw_seen++;
            this.block.contentLeft[att][this.lang] = marked;
          }
      }
      if(!!this.block.contentRight[att]){
        const marked = this._mark_kw(this.block.contentRight[att][this.lang + '_clean'], this.keywords);
        if( this.block.contentRight[att][this.lang] !== marked ){
          kw_seen++;
          this.block.contentRight[att][this.lang] = marked;
        }
      }
    }
    this.block.kw_seen = kw_seen;
  }

  is_visible(){
    if( this.block.available_in.indexOf(this.lang) === -1 ) return false
    if( this.block.allow_filter && this.block.kw_seen < 1 && !!this.keywords && this.keywords.length > 2) return false;
    return true;
  }

  sanitizeImage(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  sanitizeHtml(html: any) {
    if (!html) {
      // prevent IE to show "null"
      html = "";
    }
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  followLink(button) {
    if (button.type === "internal") {
      if (!button.detail) {
        this.router.navigate([button.url]);
      } else {
        this.router.navigate([button.url, button.detail]);
        console.log(button.url, button.detail);
      }
    } else if (button.type === "external") {
      console.log("external button");
      window.open(button.url, "_blank");
    } else if (button.type === "event") {
      console.log("event button");    
      let event;
      const eventName = button.url;
      if (typeof(Event) === 'function') {
          event = new Event(eventName);
      } else {
          // fallback for IE
          event = document.createEvent('Event');
          event.initEvent(eventName, true, true);
      }
      window.dispatchEvent(event);  
    } else {
      // do something? Tell people it's a bad link perhaps.
    }
  }
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/content-block/content-block.component.ts